import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
// Synchronous i18n bootstrap: detection (persisted vc.lang -> navigator -> en) runs at import,
// before the first render, so no component ever sees an uninitialized translator.
import './i18n/index';
import './index.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('index.html is missing the #root element');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
